import TransactionEdit from "@/controllers/transaction/transaction-edit.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import upLoad from "@/assets/img/upload_photo3.jpg";
import axios from "axios";
import store from "@/store";
import CONFIG from "@/assets/js/config.custom.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import tinycolor from "tinycolor2";
import {
    maxLength
} from "vuelidate/lib/validators";

export default {
    extends: TransactionEdit,
    components: {
        MainLayout,
        flatPickr,
        Select2Multiple,
        Loading
    },

    data() {
        return {
            imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
            inoutData: {
                payment_method_id: null,
            },
            year: '',
            academicYearArr: null,
            paymentMethodArr: null,
            isLoading: true,
            submitted: false,
            upLoad,
            ssImage: '',
            campusId: store.state.user.campus_id,
            receivedAmtValidate: false,
            receiverValidate: false,
            paidValidate: false,
            payerValidate: false,
            disabled: false,
            noDataMsg: CONFIG.NO_DATA_EXIST,
            net_total_amt: '',
            paid_amt: '',
            classArr:null,
            transactionCategoryArr: null,
            transactionTypesOptions: CONFIG.TRANSACTION_TYPES_OPTIONS,
        };
    },

    validations() {
        const baseValidations = typeof TransactionEdit.validations === 'function'
                                    ? TransactionEdit.validations.call(this)
                                    : TransactionEdit.validations || {};

        return {
            ...baseValidations,
            inoutData: {
                ...(baseValidations.inoutData || {}),
                transaction_number: {
                    maxLength: maxLength(100)
                }
            }
        };
    },

    computed: {
        hasTransactionData() {
            return this.inoutData && this.inoutData.id != null;
        },

        transactionCategorySelectSettings() {
            return {
                multiple: false,
                placeholder: "Select Transaction Category",
                templateResult: (option) => this.formatTransactionCategoryOption(option),
                templateSelection: (option) => this.formatTransactionCategoryOption(option),
                escapeMarkup: (markup) => markup,
            };
        },

        /**
         * Check Payment Date Between Selected Academic Year
        */
        showDateWarning() {
            if (!this.inoutData?.payment_date || !this.inoutData?.acd_year_id || !this.academicYearArr) {
                return false;
            }
    
            const selectedYear = this.academicYearArr.find(y => y.id == this.inoutData.acd_year_id);
    
            if (selectedYear && selectedYear.start_date && selectedYear.end_date) {
                
                const payDate = new Date(this.inoutData.payment_date);
                const startDate = new Date(selectedYear.start_date);
                const endDate = new Date(selectedYear.end_date);

                return (payDate < startDate || payDate > endDate);
            }
    
            return false;
        }
    },

    watch: {
        'inoutData.type': function(newVal) {
            if (newVal) {
                this.getTransactionCategory(newVal);
            } else {
                this.transactionCategoryArr = [];
            }
        },
        '$route.params.id'(newId, oldId) {
            if (oldId !== undefined && newId !== oldId) {
                this.isLoading = true;
                this.inoutData = {};
                this.getDetail();
            }
        },
    },

    methods: {
        /**
         * Escape HTML
         * @param {string} text
         * @return {string}
         */
        escapeHtml(text) {
            return String(text ?? "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        },

        /**
         * Validate Hex Color
         * @param {string} colorCode
         * @return {string}
         */
        validHexColor(colorCode) {
            const input = String(colorCode ?? "").trim();
            const standardHexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
            
            if (!standardHexRegex.test(input)) {
                return ""; 
            }
        
            const color = tinycolor(input);

            return color.isValid() ? color.toHexString() : "";
        },

        /**
         * Format Transaction Category Option
         * @param {object} option
         * @return {string}
         */
        formatTransactionCategoryOption(option) {
            if (!option || Number(option.id) === 0) {
                return this.escapeHtml(option?.text ?? "Select Transaction Category");
            }
            const safeText = this.escapeHtml(option.text);
            const safeColor = this.validHexColor(option.color_code);

            if (safeColor) {    
                return `<span style="display:flex;align-items:center;gap:8px;">
                            <span style="width:15px;height:15px;background:${safeColor};border:1px solid #d1d5db;display:inline-block;border-radius:2px;flex-shrink:0;"></span>
                            <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${safeText}</span>
                        </span>`;
            } else {
                return `<span style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;       max-width:100%;">${safeText}</span>`;
            }
        },

        /**
         * Get Transaction Category List With type
         * @param {string} type
         * @return {void}
         */
        getTransactionCategory(type) {
            axios
                .get("/transactionCategory/getTransactionCategoryArray?type=" + type)
                .then((res) => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Transaction Category'
                    }];
                    const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
                    const categoryOptions = categoryList.map((category) => {
                        return {
                            ...category,
                            text: category?.text ?? "",
                            color_code: category?.color_code ?? null,
                        };
                    });
                    this.transactionCategoryArr = $defaultSelectOption.concat(categoryOptions);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        /**
         * Update Transaction
         * @returns {void}
         */
        update() {
            if (this.disabled) return;
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.isLoading = true;
            if (this.ssImage) {
                this.inoutData.payment_screenshot = this.ssImage;
                this.inoutData.removeStatus = false;
            } else if (this.inoutData.removeStatus) {
                this.inoutData.payment_screenshot = '';
            }
            this.inoutData.loginID = this.$store.state.user.id;
            this.inoutData.campus_id = this.$store.state.user.campus_id;
            this.disabled = true;
            axios.post(`transaction/update/${this.$route.params.id}`, this.inoutData)
                .then(res => {
                    if (res.data) {
                        this.$notification.success("Transaction Updated Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({
                            name: "transactionList"
                        });
                    }
                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response.status == 422) {
                        this.$notification.error(error.response.data.error, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    this.isLoading = false;
                    this.disabled = false;
                });
        },

        getDetail() {
            var request = {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                    is_edit: true
                }
            }
            axios.get(`transaction/detail/${this.$route.params.id}`, request)
                .then(res => {
                    if (res.data) {
                        const data = res.data;
                        this.inoutData = {
                            type: data.type,
                            title: data.title,
                            payment_method_id: data.payment_method_id,
                            payment_date: data.payment_date,
                            amount: String(data.amount).split('.')[0],
                            incharge_name: data.incharge_name,
                            remark: data.remark,
                            transaction_number: data.ref_transaction_no,
                            acd_year_id: data.acd_year_id,
                            transaction_category_id: data.transaction_category_id,
                            invoice_number: data.invoice_number,
                            receipt_number: data.receipt_number,
                            img_path: data.img_path,
                            payment_screenshot: data.payment_screenshot,
                            class_id: data.class_id
                        };
                        this.getClass(data.acd_year_id)
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.response?.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response?.status == 422) {
                        this.$notification.error(error.response.data.error, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    this.inoutData = {};
                    this.isLoading = false;
                    console.log("Income/Expense Detail API Error", error);
                });
        },
    },

    mounted() {
        this.isLoading = true;
        this.inoutData = {};
        this.getDetail();
    },
};
